import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import Portfolio from "./pages/Portfolio";
import PortfolioListing from "./pages/PortfolioListing";
import PortfolioItem from "./pages/PortfolioItem";
import Contact from "./pages/Contact";
import ServiceDetail from "./pages/ServiceDetail";
import Commercial from "./pages/Commercial";
import Residential from "./pages/Residential";
import "./i18n/config";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services-2" element={<ServicesPage />} />
          <Route path="/service/:serviceId" element={<ServiceDetail />} />
          <Route path="/commercial" element={<Commercial />} />
          <Route path="/residential" element={<Residential />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/portfolio-9" element={<Portfolio />} />
          <Route path="/portfolio-item" element={<PortfolioListing />} />
          <Route path="/portfolio-item/:itemId" element={<PortfolioItem />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/contact-2" element={<Contact />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;